import React, { useState, useEffect } from 'react';
import { useParams, useOutletContext } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getDetailMenuCategory } from 'api/company';
import Title from 'components/backoffice/texts/title';
import MenuMattersForm from 'components/backoffice/forms/menuMattersForm';

const EditMenuCategory = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [category, setCategory] = useState(null);
  const { t } = useTranslation(['backoffice']);
  const { setTitle } = useOutletContext();

  useEffect(() => {
    const fetchCategory = async () => {
      try {
        setLoading(true);
        const { data, status } = await getDetailMenuCategory(id);
        if (status === 200) {
          setCategory(data);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchCategory();
  }, [id]);

  useEffect(()=>{
    if(category){
      setTitle(t('edit',{title: category?.name}))
    }
    return () => {
      setTitle('');
    };
  },[category, setTitle])

  return (
    <div className="mt-2">
      <Title text={t('editMenuMatters')} />
      <MenuMattersForm categoryData={category} isLoading={loading} isEditing={true} />
    </div>
  );
};

export default EditMenuCategory;
